// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3fzaS","bigColWidth":"Table_bigColWidth__4heRD","biggerColWidth":"Table_biggerColWidth__3EtEW","row":"Table_row__jrJa_","col":"Table_col__2PHC_"};